import { authorizeStore } from "./authorizeStore";

authorizeStore.restore();
